import { httpClient } from './httpClient';

export enum CaseId {
  Popunder,
  CustomPage,
}

export interface EntryResponse {
  redirect: string;
  case_id: number;
  is_buyer: boolean;
}

export const TDSApi = {
  async fetchRedirectUrl() {
    const { data } = await httpClient.get<EntryResponse>('/entry');

    return data;
  },
};
